
/*
QUE FALTA: AÑADIR CUENTA EN DOLARES Y NO SE GENEREN DESBALANCES DE CUANTO DEBE EL CLIENTE, ES DECIR SI PAGO EN DOLARES, QUE SE CONVIERTA A PESOS Y SE GUARDE EL MONTO EN PESOS, PERO QUE EL CLIENTE VEA EL MONTO EN DOLARES, Y SI PAGA EN PESOS, QUE SE GUARDE EL MONTO EN PESOS Y EL CLIENTE VEA EL MONTO EN PESOS. 
*/

export const BASE_API = "https://api.insane.digital";
//export const BASE_API = "http://127.0.0.1:8082";




export const BASE_WS = 'wss://api.insane.digital'; // para WebSocket
export const TOKEN = "token";
export const ORDER_STATUS = {
    Pendiente: "Pendiente",
    preparando: "preparando",
    listo: "listo",
    Entregado: "Entregado",
    cancelado: "cancelado"
}



export const SERVICE_TYPES = [
  { value: "web", label: "Web" },
  { value: "branding", label: "Branding" },
  { value: "ads", label: "Ads" },
  { value: "support", label: "Soporte" },
  { value: "other", label: "Otro" },
];